module.exports = {

	headView: {
		headView_lbl0: 'official website',
		headView_lbl1: 'Reservation Site TOP',
		headView_lbl2: 'My Page',
		headView_lbl3: 'Login',
		headView_lbl4: 'Languages',
		headView_lbl5: 'Japanese',
		headView_lbl6: 'Chinese',
		headView_lbl7: '06-6710-9972',
		headView_lbl8: 'Open: 9: 00 ～ 19: 00 (18: 00 last reception) Open all-year-round',
		headView_lbl9: 'My Page',
		headView_lbl10: 'Logout',
		headView_lbl11: 'Log out. Are you sure?',
		headView_lbl12: 'yes',
		headView_lbl13: 'no',
		headView_lbl14: 'English',

	},

	calendar: {
		calendar_lbl0: 'Reserve from Calendar',
		calendar_lbl1: 'Shop Reservation - Please click on the date you wish to make an appointment.',
		calendar_lbl2: 'Car Line Up',
		calendar_lbl3: 'Select a car model',
		calendar_lbl4: 'Vehicle reservations cannot be made on closed days',
		calendar_lbl5: 'reservation cannot be made for dates that have passed',
		calendar_lbl6: 'Network connection failed. Please refresh the webpage and try again!',


	},

	carline: {
		carline_1: 'Car Line Up',
		carline_2: 'Car types available for reservation',
		carline_3: 'vehicle information'
	},
	buttom: {

		buttom_lbl0: 'If you come by train, our staff will pick you up at the JR/Osaka Metro Taisho Station.',
		buttom_lbl1: '12 -21, Izumio 4-Chome, Taisho-ku, Osaka 551 0031, Japan',
		buttom_lbl2: '© 2022 MR. HIRO Rent-A-Car All Rights Reserved.',

	},
	login: {

		login_lbl0: 'Login',
		login_lbl1: 'Member login',
		login_lbl2: 'Keep logged in',
		login_lbl3: 'Login',
		login_lbl4: "If you don't already have an account, register now!",
		login_lbl5: 'Click here if you forgot your password',
		login_lbl6: 'Form validation failed',
	},
	carlinedetail: {
		carline_1: 'Look at the calendar',
		carline_2: 'riding Capacity',
		carline_3: ' gearbox ',
		carline_4: 'steering wheel',
		carline_5: 'exhaust volume',
		carline_6: 'Maximum horsepower',
		carline_7: 'The number of passengers',
		carline_8: 'Drive mode',
		carline_9: 'Length × width × height',
		carline_10: 'Optional',
		carline_11: 'Notes column',
		carline_12: 'Dedicated remarks column for vehicle-related information managers.',
		carline_13: '◯◯◯◯◯◯◯◯◯◯◯◯◯',
		carline_14: 'Book this vehicle',
		carline_15: 'Tourist login reservation',
		carline_16: 'Member login appointment',
		carline_17: 'package'
	},
	ReserveCar: {
		ReserveCar_1: 'Booking',
		ReserveCar_2: 'Booking',
		ReserveCar_3: 'Book a car model',
		ReserveCar_4: 'Appointment day',
		ReserveCar_5: 'Appointment start time',
		ReserveCar_6: 'Book a package',
		ReserveCar_7: 'Multiple days extension option',
		ReserveCar_8: 'Number of passengers',
		ReserveCar_9: 'Number of passengers (children under 6 years old)',
		ReserveCar_10: 'surname',
		ReserveCar_11: 'name',
		ReserveCar_12: 'telephone number',
		ReserveCar_13: 'Email address',
		ReserveCar_14: 'E-mail address (confirmed)',
		ReserveCar_15: 'International or geographical',
		ReserveCar_16: "Type of driver's license",
		ReserveCar_17: 'Vehicle insurance',
		ReserveCar_18: 'Payment Methods',
		ReserveCar_19: "The number of years a driver's license was obtained",
		ReserveCar_20: 'supplement ※400km ',
		ReserveCar_21: "Japanese driver's license",
		ReserveCar_22: 'SOFA License for USFJ',
		ReserveCar_23: 'Switzerland, Germany, France, Taiwan, Belgium, Slovenia, Monaco Domestic Driving License with Japanese Translation by authorizedorganization.',
		ReserveCar_24: 'International Driving Permit by the 1949 Geneva Convention',
		ReserveCar_25: 'Prepayment (Credit Card)',
		ReserveCar_26: 'Same-day payment (credit card and cash acceptable)',
		ReserveCar_27: 'Card number',
		ReserveCar_28: 'Security code',
		ReserveCar_29: 'Validity period (months/years)',
		ReserveCar_30: 'Credit card nominee (name)',
		ReserveCar_31: 'Credit card name (surname)',
		ReserveCar_32: 'Email address',
		ReserveCar_33: 'telephone number',
		ReserveCar_34: "The number of years or more to obtain a driver's license has been 3 years",
		ReserveCar_35: 'confirmation screen',
		ReserveCar_36: 'Used credit cards',
		ReserveCar_37: 'There is no data',
		
		ReserveCar_38: 'driving license less than 3 years',
		
		ReserveCar_39:"If you have obtained a driver's license for less than 3 years, you can only choose the premium insurance plan.",
		
		ReserveCar_40:'If you choose {name}, you can only choose the premium insurance package.',
		ReserveCar_41:'if your driving license is less than 3 years but still wish to make a reservation, can drop by our store or give us a call for more information.',
		ReserveCar_42:'Customers who wish to make a reservation are less than 3 years old and can come to the store directly or call our store for consultation',
		ReserveCar_43:'06-6710-9972',
		ReserveCar_44:'Postal code: 551-0031',
		ReserveCar_45:'Izumi 4-chome, Taisho-ku, Osaka Prefecture, 12−21',
		ReserveCar_46:'Open: 9: 00 ～ 19: 00 (18: 00 last reception) Open all-year-round',
		ReserveCar_47:"Thank you very much for your appointment.our store doesn't accept overseas driving license reservations [driver's license name].",
		ReserveCar_48:'Customers who wish to make a reservation can contact us by e-mail',
		ReserveCar_49:'06-6710-9972',
		ReserveCar_50:'mrhirojdm@gmail.com',
		ReserveCar_51:'Postal code: 551-0031',
		ReserveCar_52:'Izumi 4-chome, Taisho-ku, Osaka Prefecture, 12−21',
		
		ReserveCar_53:'Open: 9: 00 ～ 19: 00 (18: 00 last reception) Open all-year-round',
		ReserveCar_54:"if by any chance you've less than 3 years driving license and have chosen the 3years license to make a reservation, which is impossible, a cancelation fee will be charged.please make a reservation after confirming the date you obtained your driver's license.",
		ReserveCar_55:' (Weekdays only)※100km ',
		ReserveCar_56:' ※200km ',
		ReserveCar_57:' ※350km ',
		ReserveCar_58:' ※400km ',
		ReserveCar_59:'※There are distance limits for each plan.An additional charge of 500 yen will be applied for every 1 km exceeding the limit.',
		ReserveCar_60:'Reviewing the terms of use',
		ReserveCar_61:'If an accident occurs due to prohibited conduct (※ reference Article 18 of the Terms of Use), you may be required to pay ¥{pay} as vehicle expenses, thus falling outside the scope of insurance coverage.',
		ReserveCar_62:'YES',
		ReserveCar_63:'Consent',
		ReserveCar_64:'Confirmation items',
		ReserveCar_65:'As for overtime fees, 1000 yen will be charged for every 10 minutes beyond the time limit before 7 p.m., and 2000 yen for every 10 minutes after 7 p.m.',
		ReserveCar_66:'It takes about 30 minutes to the reception time. This is also included in the rental time.',
		ReserveCar_67:'service content ',
		ReserveCar_68:'Photography(15 cut / 19,800 yen)',
		ReserveCar_69:'Video shoot(About 120 seconds / 34,500 yen)',
		ReserveCar_70:'photo effects',
		ReserveCar_71:'video effect',
		ReserveCar_72:'Capable intersection:',
		ReserveCar_73:'Child seat free of charge (0 yen)',
		ReserveCar_74:'(mandatory for children from 0 to 6 years old)',
		ReserveCar_75:'The usage fee corresponding to the option of taking photos or videos needs to be paid in addition to the rental fee at the store on the same day.',
		ReserveCar_76:'If you are unable to use this option at the scheduled time, we will notify you separately via email instead of informing you in the booking confirmation email.',
		ReserveCar_77:'（21 years old and above）'
	},

	ResetPassword: {
		ResetPassword_lbl0: 'Registered users',
		ResetPassword_lbl1: 'Forgot password',
		ResetPassword_lbl2: 'Email address',
		ResetPassword_lbl3: 'Email verification code',

		ResetPassword_lbl4: 'Get a verification code',
		ResetPassword_lbl5: 'Password must be 6~18 digits with case and numbers.',
		ResetPassword_lbl6: 'login',
		ResetPassword_lbl7: 'password',

	},

	Register: {
		Register_lbl0: 'Sign Up',
		Register_lbl1: 'Registered users',
		Register_lbl2: 'Email address',
		Register_lbl3: 'Email verification code',
		Register_lbl4: 'Get a verification code',
		Register_lbl5: 'password',
		Register_lbl6: 'Password must be 6~18 digits with case and numbers.',
		Register_lbl7: 'I have read and agree to the User Agreement.',
		Register_lbl8: 'login',
		Register_lbl9: 'Users who already have an account',
		Register_lbl10: 'login',
		Register_lbl11: 'Please click',


		Register_lbl12: 'Please enter your email address',
		Register_lbl13: 'Please enter a correct email address',
		Register_lbl14: 'Please enter the verification code',
		Register_lbl15: 'Please enter a password',
		Register_lbl16: 'Login complete',
		Register_lbl17: 'Log in and read and agree to the User Agreement below',
		Register_lbl18: 'Logged in',
		Register_lbl19: 'The user does not exist',
		Register_lbl20: 'Please enter the correct password',
		Register_lbl21: 'Network connection error',
		Register_lbl22: 'The user already exists',
		Register_lbl23: 'Login failed',
		Register_lbl24: 'The password has been changed',
		Register_lbl25: 'Failed to change password',
		Register_lbl26: 'The confirmation password was entered incorrectly',
		Register_lbl27: 'Please enter a first name',
		Register_lbl28: 'Please enter a name',
		Register_lbl29: 'Send a verification code',
	},

	Reservesure: {
		Reservesure_1: 'total',
		Reservesure_2: 'Book this content',
		Reservesure_3:'not',
		Reservesure_4:'Correct the content'
	},
	Reservesub: {
		Reservesub_1: 'Thank You !',
		Reservesub_2: 'You have successfully made an appointment',
		Reservesub_3: '[Appointment completion email notification] has been sent to the email address you logged in',
		Reservesub_4: 'Please check',
		Reservesub_5: 'Your reservation failed',
		Reservesub_6: 'Please check UNIVAPAY for the reason of the payment failure',
		Reservesub_7: 'Please make a new reservation',
	},
	infoview: {
		infoview_1: 'MENU',
		infoview_2: 'User details',
		infoview_3: 'About your order',
		infoview_4: 'Change the password',
		infoview_5: 'My points'
	},
	UserInfo: {
		UserInfo_1: 'User Information',
		UserInfo_2: 'User details',
		UserInfo_3: 'Email address',
		UserInfo_4: 'telephone number',
		UserInfo_5: 'surname',
		UserInfo_6: 'name',
		UserInfo_7: 'identity card',
		UserInfo_8: 'ID number',
		UserInfo_9: 'Date of birth',
		UserInfo_10: 'Emergency contact name',
		UserInfo_11: 'Emergency contact phone number',
		UserInfo_12: 'login',
		UserInfo_13: 'Credit card details',
		UserInfo_14: 'Logged in',
		UserInfo_15: 'Not logged in',
		UserInfo_16: 'Change credit card information',
		UserInfo_17: 'Log in credit card',
		UserInfo_18: 'Change credit card',
		UserInfo_19: 'Please enter your credit card number',
		UserInfo_20: 'Please enter the security code',
		UserInfo_21: 'Please enter the name of the credit card (first name)',
		UserInfo_22: 'Please enter the name of the credit card(surname) ',
		UserInfo_23: 'Please enter your email address',
		UserInfo_24: 'telephone number',
		UserInfo_25: 'Successfully logged in',
	},
	OrderInfo: {
		OrderInfo_1: 'Appointment records',
		OrderInfo_2: 'Order number',
		OrderInfo_3: 'Vehicle type',
		OrderInfo_4: 'Car rental start time',
		OrderInfo_5: 'Time of use',
		OrderInfo_6: 'Payment Methods',
		OrderInfo_7: 'not',
	},

	ModifyPwd: {
		ModifyPwd_lbl0: 'Change the password',
		ModifyPwd_lbl1: 'Captcha',
		ModifyPwd_lbl2: 'Send a verification code',
		ModifyPwd_lbl3: 'password',
		ModifyPwd_lbl4: 'Confirm the password',
		ModifyPwd_lbl5: 'login',

	},
	OrderInfoDetail: {
		OrderInfoDetail_1: 'Total amount',
		OrderInfoDetail_2: 'To confirm the contents of the login, click [Reserve this content] at the bottom of the page to complete the reservation',
		OrderInfoDetail_3: 'person',
		OrderInfoDetail_4:'not'
	},
	Points: {
		Points_1: 'View points',
		Points_2: 'About points',
		Points_3: 'Use Points',
		Points_4: 'Rules for the use of points',
		Points_5: 'Date of awarding points',
		Points_6: 'Order Kind',
		Points_7: 'Number of points',
	},
	bx: {
		bx_1: 'No vehicle compensation insurance',
		bx_2: 'Basic package + 3000/day',
		bx_3: 'Assured package +5000/day',
		bx_4: 'Compensatory Content',
		bx_5: 'Compensation to people',
		bx_6: 'Unlimited',
		bx_7: 'The amount of vehicle compensation insurance burden：',
		bx_8: 'The repair cost is fully covered',
		bx_9: 'Compensation in rem：',
		bx_10: '200,000 yen',
		bx_11: 'Personal injury insurance can be compensated up to 30 million yen for one person：',
		bx_12: 'Damage that exceeds the above self-pay and compensation limit will be borne by the customer. No compensation will be made in the event of an accident that falls under the circumstances where insurance premiums cannot be paid. No compensation will also be given if there is no accident number issued by the police.',
		bx_13: "In the case of vehicle failure caused by accident or user's fault, the user will bear the vehicle maintenance costs and other expenses and the standstill costs that cannot be used during vehicle maintenance. The specific cost will vary according to the degree of vehicle damage and the time required for repair. Please let us know",
		bx_14: 'Insurance compensation system',
		bx_15: 'In the case of returning the vehicle by returning to the store by yourself',
		bx_16: '150,000 yen',
		bx_17: 'If you are unable to return to the store by yourself, return to the vehicle',
		bx_18: '300,000 yen',
		bx_19: '500,000 yen',
		bx_20: 'Insurance compensation system',
		bx_21: 'If you are not insured, please present your original vehicle insurance certificate. If you cannot provide this, we will not be able to lend to you. We ask for your understanding in this matter.',
	},
	bc:{
		bc_1:'Please enter a phone number',
		bc_2:'Please enter a surname',
		bc_3:'Please enter a name',
		bc_4:'Please enter your ID card',
		bc_5:'Please enter your ID number',
		bc_6:'Please enter your date of birth',
		bc_7:'Please enter an emergency contact',
		bc_8: 'Please enter the phone number of the emergency contact',
		bc_9: 'Please enter the correct password',
		bc_10: 'Please enter the reservation start time',
		bc_11: 'Please select a plan',
		bc_12: 'Please select the number of passengers',
		bc_13: 'E-mail address (confirmed)',
		bc_14: 'Email addresses are entered inconsistently',
		bc_15: 'Please enter an international or regional location',
		bc_16: "Please enter the type of driver's license",
		bc_17: 'Please select the type of insurance',
		bc_18: 'Please select a payment method',
		bc_19: 'The reservation was successful',
		bc_20: 'Reservation failed',
		bc_21: 'name',
		bc_22: 'cc',
		bc_23:'ps',
		bc_24:'The user does not exist',
		bc_25:'More than the specified number of people',
		bc_26:'Please enter your credit card number',
		bc_27:'Please enter the security code',
		bc_28:'Please enter credit card expiration date (months)',
		bc_29:'Please enter credit card expiration date (years)',
		bc_30:'Credit card nominee ( name)',
		bc_31:'Credit card nominee (surname)',
		bc_32:'Email address',
		bc_33:'Please enter the number of passengers for more than 1 passenger',
		bc_34:"Please select the number of years your driver's license has been obtained",
		bc_35:'Login failed. Please reconfirm the information entered',
		bc_36:'The user name or password is incorrect',
		bc_37:'Login failed. Please reconfirm the information entered',
		bc_38:'Please enter required',
		bc_39:'The email address is already registered',
		bc_40:'Please enter the verification code',
		bc_41:'Login failed. Please try again.',
		bc_42:'Password',
		bc_43:'Please enter 1~12 digits',
		bc_44:'Please enter the name of the person in your credit card (surname)',
		bc_45:'Please enter the name of the person in your credit card (name)',
		bc_46:'A verification code has been sent',
		bc_47:'Please enter the correct phone number',
		bc_48:'Please enter the correct date of birth',
		bc_49:'Logging in',
		bc_50:'Please wait',
		bc_51:'Appointments are being processed',
		bc_52:'Sending',
		bc_53:'Please enter the correct verification code',
		bc_54:'Please enter the correct expiration date',
		bc_55:'The appointment date you selected has already been booked. Please try again.',
		bc_56:'Please confirm the terms of use.。',
	},
	agree:{
		agree1:'MR. HIRO POINT MEMBERSHIP RULES',
		agree2:"Nichie Co., Ltd. (hereinafter referred to as 'our company') is a company that provides the Company's services (hereinafter referred to as 'Services') to members who complete the procedures and rules prescribed by the Company. The following 'ME. The HIRO POINT Membership Agreement (hereinafter referred to as the 'Membership Agreement') applies to the use of the Services by members who complete the procedures prescribed by the Company.",
		agree3:'Article 1 (Scope of Application)',
		agree4:'This Membership Agreement applies to the use of the Services by us and our Members',
		agree5:'Article 2 (Definition of Terms)',
		agree6:'The main terms defined in the Membership Agreement are as follows',
		agree7:'(1) "HIROPOINT" IS THE NAME OF THE POINTS GRANTED BY THE COMPANY TO HIRO POINT MEMBERS, AND THE INDIVIDUAL POINTS AWARDED OR USED BY HIRO POINT ARE HEREINAFTER REFERRED TO AS "POINTS".',
		agree8:'(2) "HIRO APP" is a smartphone application provided by the Company for registering HIRO POINT members and using HIRO POINT.',
		agree9:'(3) "Member ID Information" refers to the User ID, password, e-mail address and other Member information that the Company agrees that the User needs to use the POINT Application.',
		agree10:'(4) "Points Balance" refers to the number of Points accumulated in the Points Account through the use of HIRO POINT services.',
		agree11:'Article 3 (Membership)',
		agree12:'(1) Associate members shall agree to the membership terms and conditions of the Company through POINT App and register as members in accordance with the procedures prescribed by the Company. Once the member information is registered in the company system, the member registration of the prospective member shall be completed. However, if there is any omission in membership information, membership registration may not be completed.',
		agree13:'(2) If the Associate does not agree to the Membership Terms and Conditions, the Associate Member cannot become a Member. In addition, if you are a gang member, an associate member of a gang, a gang-related person, a gang-related company or a member of the Great Hall, or any other antisocial force (antisocial force), you will not be able to become a member. Members of antisocial forces (hereinafter referred to as "antisocial forces") (including those who have been members in the past five years). (2) Members of antisocial forces (hereinafter referred to as "antisocial forces") (including members within the past five years) or people related to members of antisocial forces, as well as those who abuse the service or cause trouble to third parties, are not allowed to use the service',
		agree14:'(3) If it is found that an associate member falls under any of the contents specified in Article 12, it is not possible to register as a member. In addition, if it is found that there is any of the contents stipulated in Article 12, the Company may suspend or cancel its membership even after completing the membership registration.',
		agree15:"(4) Since the target of HIRO POINT's services is individuals, the company cannot become a member.",
		agree16:'Article 4 (Management of ID and Password)',
		agree17:'(1) member shall be responsible for their own accounts, ID and password.',
		agree18:'(2) members are not allowed any third party to use their membership including lending, transferring, name changing, selling, buying or pledging. etc.',
		agree19:"(3) The Company shall perform any procedural procedures and operations regarding the legitimate member's information as the member. If a third party uses the member's identity information to cause damage, the member shall bear the corresponding responsibility, and the company shall not bear any damage.",
		agree20:'(4) if members notice that the membership information has been leaked or that identity information is being used by a third-party. members shall contact the company straight away and follow the instructions issued by the company',
		agree21:'Article 5 (Change of Member Information or Member Identity Information)',
		agree22:'(1) If there is any change in the member information or member identity information, the member shall change the registration information on the POINT APP or contact the Company.',
		agree23:"(2) If changes are not made in accordance with the provisions of the preceding paragraph, members may not receive necessary information or notifications, and may not be able to receive services such as point rewards. The Company will not be liable for any loss or damage caused by the Member's failure to make such modifications.",
		agree24:'Article 6 (Awarding of Points)',
		agree25:'The Company will award points to members under the following conditions. In addition, points may not be awarded depending on the product, service content, or payment method purchased.',
		agree26:'(1) Points purchased by the Company in accordance with the prescribed procedures',
		agree27:'(2) Points allocation attached to the purchase of the aforementioned items',
		agree28:'(3) Points activities or other methods of issuance conducted by the Company',
		agree29:'Article 7 (Validity Period of Points)',
		agree30:'The granting and use of Points shall be valid within 6 months from the date of granting Points in accordance with the provisions of the preceding article, and shall be deemed invalid upon expiry.',
		agree31:'Article 8 (Use of Points)',
		agree32:"(1) Members may use their points to pay for all or part of the cost of purchasing the Company's products or enjoying the Company's services.",
		agree33:'(2) Points cannot be exchanged for cash or refunded for cash',
		agree34:'Article 9 (Prohibition of Transfer of Points)',
		agree35:'Members may not transfer, lend or guarantee their Points to others. Members may not transfer or borrow points held by other Members. Except when the above operations are carried out in accordance with the procedures prescribed by the Company.',
		agree36:'Article 10 (Cancellation, Expiration and Modification of Points)',
		agree37:"(1) Members may use their points to pay for all or part of the cost of purchasing the Company's products or enjoying the Company's services.",
		agree38:"(2) The balance of points shall be based on the data recorded through the POINT application and stored in the Company's system (hereinafter referred to as 'Data'). If the data displayed on the POINT application differs from the data displayed within the Company, the data in the Company's system will be regarded as the correct point balance.",
		agree39:'(3) If the Company mistakenly grants any member points, or if there is another reason to correct the current point balance, the Company has the right to make appropriate point balance adjustments or adjust the right to the correct point balance.',
		agree40:'(4) In the event of any of the following events, the entire point balance at the time of the event will expire and the points will not be available. Points that have expired will not be re-granted for any reason.',
		agree41:'　①　If the expiration date of the points specified in Article 7 has passed',
		agree42:'　②　In the event that the member initiates membership or loses membership',
		agree43:'　③　If the Company determines that the withdrawal of Points is appropriate and necessary under certain circumstances',
		agree44:'Rule 11 (Withdrawal from Membership)',
		agree45:'Members may withdraw from the membership at any time, and the withdrawal shall be subject to the procedures prescribed by the Company. Upon completion of the withdrawal process, any points earned at the time of withdrawal will be forfeited. Points that expire for any reason will not be reawarded.',
		agree46:'Article 12 (Compulsory Withdrawal)',
		agree47:'(1) If the Company determines that a member is suspected to belong to any of the following foreign lands, the Company reserves the right to suspend the membership until the problem is resolved. In the event of loss of membership without resolution, any Points previously awarded to a Member will expire at the time of loss of membership.',
		agree48:'　①　If the Member violates the Membership Agreement or any other terms and conditions otherwise stipulated by the Company',
		agree49:'　②　If the Member has initiated the Membership in accordance with the provisions of Article 11',
		agree50:'　③　If the member is found to be an antisocial force (including if the member has been a member of an antisocial force in the past five years)',
		agree51:'　④　If the member does not exist (including in the event of death of the member for any reason)',
		agree52:'　⑤　If the member has been suspended or confiscated in the past due to violation of the membership rules',
		agree53:'　⑥　If the information provided by the member to the Company during the registration process is false, incorrect or omitted',
		agree54:'　⑦　If the member is under guardianship, protection or assistance and has not obtained the consent of an adult guardian, guardian or assistant',
		agree55:'　⑧　If the member earns and uses points without authorization or otherwise',
		agree56:'　⑨　If the member is otherwise judged by the Company to be unsuitable as a member',
		agree57:'(2) The Company reserves the right to cancel the eligibility of a member who cannot be contacted due to a change in the address, telephone number, e-mail address, etc. registered with the Company',
		agree58:'(3) The Company reserves the right to cancel the membership of any membership that does not have any change in the position at the end of the month of the last month after one year after the start of the last activity date',
		agree59:'Article 13 (Suspension and Termination of Service)',
		agree60:'(1) The Company has the right to suspend or terminate the service for HIRO POINT membership in the following cases',
		agree61:'　①　When HIRO POINT service requires equipment for maintenance or inspection, or in the event of a failure',
		agree62:'　②　When the Company decides to suspend or terminate the HIRO POINT service',
		agree63:'　③　In the event of any other uncontrollable circumstances',
		agree64:'(2) The Company shall not be liable for any loss or other disadvantage caused to the member due to the interruption or termination of HIRO POINT services',
		agree65:"(3) The Company shall notify members before the interruption or termination of HIRO POINT's services. However, this clause shall not apply to any uncontrollable or any emergency of the Company",
		agree66:"Article 14 (Collection, Use, Provision, etc. of Members' Personal Information)",
		agree67:'【Consent to the collection, use, provision of personal information, etc. of members】',
		agree68:"The Customer agrees that the Company will collect and use the Member's information in accordance with the methods specified in paragraph 2 after taking the necessary security measures",
		agree69:'【Items to be collected, used and provided】',
		agree70:'The Company will use the following personal information of members for the purposes described in paragraph 3',
		agree71:'　①　Items provided by members at the time of application for membership, such as name, address, telephone number, date of birth, gender, and e-mail address, as well as items provided by members after becoming a member',
		agree72:'　②　Information obtained by members who fill in the relevant matters entered into the contract with the Company, such as date of enrollment, membership card number, etc. (including point allocation and usage history, purchase history (date and time of use, store of use, amount of use, products purchased, payment methods, etc.), history of various services related to HIRO POINT member information, etc.',
		agree73:'　③　Publicly available information, such as official gazettes or telephone directories',
		agree74:'　④　When using the HIRO POINT APP, information such as the IP address, location information, and solid-state identification number of the device are obtained',
		agree75:'【Purpose of use of personal information by the company】',
		agree76:'　①　The service provided by the points that provide HIRO POINT services',
		agree77:"　②　Analyze the use of HIRO POINT services, conduct market research based on customers' interests and hobbies, and conduct product development and marketing",
		agree78:'　③　We analyze information such as browsing history and purchasing power obtained, send promotional materials such as business products, point rewards and services operated by the Company and its partners, develop advertisements, and provide related sales information',
		agree79:'　④　Contact members for transactions or contacts if necessary, and please confirm details',
		agree80:"　⑤　To register and maintain and manage the Company's member organizations, as well as in connection with the provisions of Article 5",
		agree81:'　⑥　Provision of personal information to third parties in accordance with legal procedures for the purpose of providing HIRO POINT services',
		agree82:'　⑦　For other purposes similar to or related to the purpose of appeal',
		agree83:'【Provision of personal information to third parties】',
		agree84:"The Company will provide the member's personal information described in Article 2 to affiliated companies, etc. to the extent necessary to achieve the items in Article 3. The Company will not accept proposals to provide personal information only to specific groups or companies or tenants and not to other group companies or tenants",
		agree85:'【Exceptions to the provision of personal data to third parties】',
		agree86:'In the following cases, personal information may be provided to a third party without the prior consent of the member',
		agree87:'　①　When required by law',
		agree88:'　②　When it is necessary to protect the life, body, or property of a person, and it is difficult to obtain the consent of the member',
		agree89:'　③　When it is particularly necessary to improve public health or the sound development of children, and it is difficult to obtain the consent of the person concerned',
		agree90:'　④　When it is necessary to cooperate with State organs, local authorities or persons or entities entrusted by them in the execution of affairs prescribed by law, and obtaining the consent of the person concerned may hinder the execution of the relevant affairs',
		agree91:'【Outsourcing of personal information】',
		agree92:"The Company may provide the member's personal information described in Article 2 to a third party outsourced by the Company in order to achieve the purpose of use described in Article 3",
		agree93:'【Differences in handling personal information】',
		agree94:"If a member is unwilling to provide the necessary information when applying for membership, or does not agree to all or part of the terms of this agreement, the Company may refuse the member's eligibility or take measures to cancel his/her membership",
		agree95:"【Contact for inquiries about members' personal information】",
		agree96:'For inquiries or comments regarding the personal information of members, please contact the Company directly',
		agree97:'Article 15 (Change of Rules, etc.)',
		agree98:'The Company may modify the Membership Agreement to the extent prescribed by law. In principle, changes to terms and conditions shall be made to users at least 60 days in advance through the POINT app, etc. This does not apply if the modification is in the interest of the member. After the content is modified, it is deemed to be the latest user agreement and is true and valid',
		agree99:'Article 16 (Disclaimer)',
		agree100:'(1) Unless intentionally committed by the Company or gross negligence, the user shall not be liable for any damage, etc. caused by the use of HIRO POINT',
		agree101:'(2) If the Company undertakes to be liable for damages caused by the member during the use of HIRO POINT, the damage compensated by the Company shall be limited to ordinary or direct damage. Under no circumstances shall the Company be liable for indirect damages, special damages, incidental damages, loss of profits, or loss of foundational damages',
		agree102:'Article 17 (Governing Law)',
		agree103:'The formation, validity, performance and interpretation of the membership agreement and any contract related to the use of HIRO POINT services shall be governed by the laws of Japan',
		agree104:'Article 18 (Dispute Settlement)',
		agree105:'In the event that a dispute arises between a member and the Company related to HIRO POINT services and cannot be resolved, the Osaka District Court shall be the exclusive jurisdiction court of the first instance',
		agree106:'Article 19 (Enforcement and Period of Commencement of Force)',
		agree107:'This Membership Agreement will be effective from 00:00 Japan Standard Time on December 1, 2022',
		agree108:'end'
	}



}
